'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'motorcycle';
var width = 640;
var height = 512;
var aliases = [127949];
var unicode = 'f21c';
var svgPathData = 'M456 32l-8.7 0-6.7 5.6-49 41.1L373.1 44.6 366.3 32 352 32l-72 0-24 0 0 48 24 0 57.7 0 16.4 30.3-95.2 80C223.1 161.3 177.6 144 128 144l-72 0-24 0 0 48 24 0 72 0c88.4 0 160 71.6 160 160l0 32 16 0s0 0 0 0l48 0 0-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128l69.8 0 24 0 0-24 0-48 0-24-24 0-32 0zM392.6 181.6c-32 22.5-57.4 53.7-72.6 90.2c-7.1-17-16.4-32.8-27.5-47.2l84.9-71.3 15.3 28.2zM432 352c0-21.7 8.6-41.3 22.6-55.7l36.3 67.1 11.4 21.1 42.2-22.8-11.4-21.1-36.3-67.1c4.9-.9 10-1.4 15.2-1.4c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80zM204.3 328l-55.2 0c-5.6-5-13.1-8-21.2-8c-17.7 0-32 14.3-32 32s14.3 32 32 32c8.1 0 15.5-3 21.2-8l55.2 0c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80s35.8-80 80-80c35.8 0 66.1 23.5 76.3 56zM128 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMotorcycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;